<template><div><h1 id="transaktionen-abschliessen" tabindex="-1"><a class="header-anchor" href="#transaktionen-abschliessen"><span>Transaktionen abschliessen</span></a></h1>
<p>Transaktionen abschliessen — Nicht bezahlte LSV-Transaktionen abschliessen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Nach erfolglosen LSV-Belastungen gibt es keine Rückmeldung der Bank. Dieser Job sorgt dafür, dass mehrfach erfolglose LSV-Belastungen trotzdem abgeschlossen werden können. Frühestens 3 Tage nach dem Valutadatumm der eingelesenen Gutschriften (weil immer noch nachträglich Gutschriften erfolgen können) werden die nicht bezahlten LSV-Transaktionen gemäss den Einstellungen in der Tabelle <RouteLink to="/referenz/refs/ft.refdata.tbladrwiderruflsv.html" title="Widerrufe Parametrisierungen">Widerrufe Parametrisierungen</RouteLink> verarbeitet und abgeschlossen.</p>
<h2 id="start-parameter" tabindex="-1"><a class="header-anchor" href="#start-parameter"><span>Start &amp; Parameter</span></a></h2>
<p>Pfad: Adressen → Verarbeitungsläufe → Zusagen → Zusagenfakturierung → Menü → Transaktionen abschliessen...</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>bis Datum</dt>
<dd>Nur Zusagenfakturierungen, deren Fakturadatum &lt;= &quot;bis Datum&quot; liegt, werden berücksichtigt.</dd>
<dt>Zusagearten</dt>
<dd>Zusagearten die berücksichtigt werden sollen (* oder kommagetrennte Eingabe)</dd>
<dt>nicht bezahlte Transaktionen abschliessen</dt>
<dd>Option &quot;Testlauf: Es wird eine Liste mit den nicht bezahlten Transaktionen erstellt.<br>Option &quot;Verarbeiten&quot;: Wenn eine LSV-Transaktion als &quot;nicht bezahlt&quot; deklariert ist oder ein Widerruf eingelesen wird, werden in funtrade Aktionen zu der betreffenden Zusage ausgelöst (siehe <a class="link" href="ft.refdata.tbladrwiderruflsv.html" title="Widerrufe Parametrisierungen">Widerrufe Parametrisierungen</a>).</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Zeigt alle LSV-Transaktionen ohne Gutschrift, Stornierung, die noch nicht abgeschlossen sind</p>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>Sämtliche Fakturierungspositionen werden beim LSV-Export in die Tabelle &quot;mitfalnk&quot; eingetragen: mitfalnk.jobdat+jobnum+posnum (Schlüssel zu &quot;zusakopf&quot; + &quot;zu-sapos&quot;) mitfalnk.adrnum (Schlüssel zur Adresse &quot;adr&quot;).</p>
<p>Dabei werden die folgenden Stati verwendet:</p>
<table>
<thead>
<tr>
<th>Code</th>
<th>Bezeichnung</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>0</td>
<td>exportiert</td>
<td>Default nach Export</td>
</tr>
<tr>
<td>1</td>
<td>bezahlt</td>
<td>wenn Gutschrift erfolgt ist</td>
</tr>
<tr>
<td>2</td>
<td>nicht bezahlt</td>
<td>nach Abschluss-Funktion</td>
</tr>
<tr>
<td>3</td>
<td>storniert</td>
<td>Widerruf/ Rückbuchung</td>
</tr>
</tbody>
</table>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>Dieser Job setzt alle Transaktionen mit Status 0 auf Status 2 und löst die Aktionen gemäss <RouteLink to="/referenz/refs/ft.refdata.tbladrwiderruflsv.html" title="Widerrufe Parametrisierungen">Widerrufe Parametrisierungen</RouteLink> aus.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.tbladrwiderruflsv.html" title="Widerrufe Parametrisierungen">Widerrufe Parametrisierungen</RouteLink></p>
</div></template>


